import Router from '@/router'
class routerHistory {
  routerHistoryList = []
  constructor() {
    this.routerHistoryList = [] // 存路由历史的数组
    this.lastIsBack = false // 记录跳转页面是否是历史页面
  }

  delCurrentRouter() {
    this.routerHistoryList.pop()
  }

  replacePage() {
    this.routerHistoryList = []
  }

  pushPage(page) {
    if (this.lastIsBack) {
      // 是历史页面时不添加进记录
      this.lastIsBack = false
      return false
    }
    this.routerHistoryList.push(page)
  }

  goLastPage() {
    this.lastIsBack = true
    if (this.routerHistoryList.length > 1) {
      this.delCurrentRouter() // 去掉当前路由
      // 存在历史路由
      let lastRouter = this.routerHistoryList[this.routerHistoryList.length - 1]
      this.delCurrentRouter() //去掉上一个路由历史
      Router.replace({ name: lastRouter.name, query: lastRouter.query })
    } else {
      this.replacePage()
      Router.replace({
        name: 'h5-video-clip-home'
      })
    }
  }
}
export default new routerHistory()
